import { Helmet } from 'react-helmet-async';

export default function PageMeta({ title, description }) {
  const siteName = 'UNIKOL';
  const fullTitle = title ? `${title} — ${siteName}` : siteName;
  const desc = description || 'Plateforme d\'accompagnement pour étudiants internationaux à Kolwezi. Logements, démarches, guide pratique, communauté.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
